import { Store } from 'utils';

class LatestResumes extends Store {

	getInitialState() {
		return {
			resumes: []
		}
	}

	onLatestResumesChanged(state, data) {
		state.resumes = data.resumes;
	}
}

const store = new LatestResumes();
export default store;


// WEBPACK FOOTER //
// ./src/modules/model/LatestResumes.js